import { Layout, ConfigProvider } from "antd";
import AppFooter from "./components/common/Footer";
import AppHeader from "./components/common/Header";
import AppRoutes from "./components/pages/Routes";
import "./App.css"
import { BrowserRouter } from "react-router-dom";
import { Amplify } from 'aws-amplify';
import { auth_config } from 'config/aws_exports';
import Authenticator from "components/Authenticator";
import { AuthenticatorProvider } from "@aws-amplify/ui-react-core";
import PostAuthenticationInit from "components/PostAuthenticationInit";

Amplify.configure(auth_config)

// Enterprise Design System Theme Configuration
const enterpriseTheme = {
  token: {
    // Primary Colors
    colorPrimary: "#00857C",
    colorPrimaryHover: "#006B63",
    colorPrimaryActive: "#005249",
    colorPrimaryBg: "#E6F4F3",
    colorPrimaryBgHover: "#D1EEEC",
    
    // Border Radius - Refined and consistent
    borderRadius: 6,
    borderRadiusLG: 8,
    borderRadiusSM: 4,
    borderRadiusXS: 2,
    
    // Typography
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    fontSize: 14,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSizeXL: 20,
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
    
    // Colors
    colorBgContainer: "#FFFFFF",
    colorBgLayout: "#F9FAFB",
    colorBgElevated: "#FFFFFF",
    colorBorder: "#E5E7EB",
    colorBorderSecondary: "#F3F4F6",
    
    // Text Colors
    colorText: "#1F2937",
    colorTextSecondary: "#6B7280",
    colorTextTertiary: "#9CA3AF",
    colorTextQuaternary: "#D1D5DB",
    
    // Link Colors
    colorLink: "#00857C",
    colorLinkHover: "#006B63",
    colorLinkActive: "#005249",
    
    // Success, Warning, Error
    colorSuccess: "#059669",
    colorWarning: "#D97706",
    colorError: "#DC2626",
    colorInfo: "#2563EB",
    
    // Shadows
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
    boxShadowSecondary: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
    
    // Control Heights
    controlHeight: 36,
    controlHeightLG: 44,
    controlHeightSM: 28,
    
    // Motion
    motionDurationFast: "0.1s",
    motionDurationMid: "0.2s",
    motionDurationSlow: "0.3s",
  },
  components: {
    Menu: {
      itemBg: "transparent",
      colorText: "#374151",
      colorTextDescription: "#6B7280",
      itemSelectedBg: "#E6F4F3",
      itemSelectedColor: "#00857C",
      itemHoverBg: "#F3F4F6",
      itemHoverColor: "#00857C",
      horizontalItemSelectedColor: "#00857C",
      horizontalItemHoverColor: "#00857C",
      itemMarginInline: 4,
    },
    Button: {
      primaryShadow: "0 1px 2px 0 rgba(0, 133, 124, 0.2)",
      defaultShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      fontWeight: 500,
    },
    Card: {
      borderRadiusLG: 8,
      paddingLG: 24,
      boxShadowTertiary: "0 1px 2px 0 rgba(0, 0, 0, 0.03)",
    },
    Table: {
      headerBg: "#F9FAFB",
      headerColor: "#374151",
      rowHoverBg: "#F9FAFB",
      borderColor: "#E5E7EB",
      headerSplitColor: "#E5E7EB",
    },
    Input: {
      activeBorderColor: "#00857C",
      hoverBorderColor: "#00857C",
      activeShadow: "0 0 0 2px rgba(0, 133, 124, 0.1)",
    },
    Select: {
      optionSelectedBg: "#E6F4F3",
      optionActiveBg: "#F3F4F6",
    },
    Steps: {
      colorPrimary: "#00857C",
      finishIconBorderColor: "#059669",
    },
    Modal: {
      borderRadiusLG: 12,
      paddingContentHorizontalLG: 24,
    },
    Notification: {
      borderRadiusLG: 8,
    },
    Tag: {
      borderRadiusSM: 12,
    },
    Tabs: {
      inkBarColor: "#00857C",
      itemActiveColor: "#00857C",
      itemHoverColor: "#00857C",
      itemSelectedColor: "#00857C",
    },
    Divider: {
      colorSplit: "#E5E7EB",
    },
    Progress: {
      defaultColor: "#00857C",
    },
  },
};

const App = () => {
  return (
    <AuthenticatorProvider>
      <Authenticator>
        <PostAuthenticationInit>
          <BrowserRouter>
            <ConfigProvider theme={enterpriseTheme}>
              <Layout style={{ minHeight: "100vh", background: "#F9FAFB" }}>
                <div className="app-wrapper">
                  <div>
                    <AppHeader />
                    <div style={{ 
                      padding: "24px 32px", 
                      maxWidth: "1600px", 
                      margin: "0 auto",
                      width: "100%"
                    }}>
                      <AppRoutes />
                    </div>
                  </div>
                  <AppFooter />
                </div>
              </Layout>
            </ConfigProvider>
          </BrowserRouter>
        </PostAuthenticationInit>
      </Authenticator>
    </AuthenticatorProvider>
  );
};
export default App;
